<template>
  <div class="pkss-bg-color">
    <SideMenu v-show="showMainMenu"></SideMenu>
    <Header></Header>

    <router-view></router-view>

    <Footer
      v-if="
        ![
          'onBoarding',
          'ProfileEdit',
          'ProfileFAQ',
          'ProfileDocuments',
          'acceptContract'
        ].includes($route.name) &&
          (['offerSearch'].includes($route.name) || loggedIn)
      "
    ></Footer>
    <!--    <Footer-->
    <!--      v-if="-->
    <!--        ![-->
    <!--          'checkLastname',-->
    <!--          'checkLastnameFailed',-->
    <!--          'confirmCell',-->
    <!--          'confirmOtp',-->
    <!--          'acceptContract'-->
    <!--        ].includes($route.name)-->
    <!--      "-->
    <!--    ></Footer>-->

    <CookieAlert v-if="false"></CookieAlert>

    <portal-target name="modals"></portal-target>

    <portal to="modals">
      <SignIn
        v-if="showSignInModal"
        :prevent-redirect-on-close="true"
        @close="$store.commit('app/hideSignInModal')"
      >
      </SignIn>
      <GdprModal v-if="showGdprModal" @close="closing"></GdprModal>

      <AgreementModal />
      <UpdateAvailabilityModal />
    </portal>
    <notification />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PortalTarget, Portal } from "portal-vue";

import Header from "@/components/header/Header";
import SignIn from "@/components/modals/SignInModal";
import CookieAlert from "../components/CookieAlert";
import GdprModal from "../components/modals/GdprModal";
import UserService from "../services/userOld.service";
import AgreementModal from "../components/modals/AgreementModal";
import UpdateAvailabilityModal from "../components/modals/UpdateAvailabilityModal";
import { EventBus } from "@/event-bus";
import Footer from "@/components/Footer";
import SideMenu from "@/components/menu/Menu";
import Notification from "@/components/modals/Notification";

export default {
  name: "AppLayout",
  components: {
    Notification,
    SideMenu,
    UpdateAvailabilityModal,
    AgreementModal,
    GdprModal,
    CookieAlert,
    SignIn,
    Header,
    PortalTarget,
    Portal,
    Footer
  },
  computed: {
    ...mapGetters("app", {
      showMainMenu: "showMainMenu",
      showConfirmIdentityModal: "showConfirmIdentityModal",
      showSignInModal: "showSignInModal",
      showGdprModal: "showGdprModal"
    }),
    ...mapGetters("dlGroupConfig", [
      "getDlGroupName",
      "getLogoUrl",
      "getAddress"
    ])
  },
  methods: {
    closing() {
      this.$store.commit("app/hideGdprModal");
    },

    changeLanguage(language) {
      this.$i18n.locale = language;
      if (this.loggedIn) {
        UserService.setLanguage(language).then(async () => {
          EventBus.$emit("on-change-local", language);
          this.$store.dispatch("auth/filter");
        });
      } else {
        this.$store.dispatch("auth/anonymisedFilter");
        EventBus.$emit("on-change-local");
      }
      this.updateInfoPage();
      const html = document.documentElement; // returns the html tag
      html.setAttribute("lang", this.$i18n.locale);
    },

    updateInfoPage() {
      this.$store.dispatch("dlGroupConfig/getInfoPage", this.$i18n.locale);
    }
  }
};
</script>

<style scoped></style>
